import React from 'react';
import { ThemeProvider } from 'styled-components';
import DEVICE_BREAKPOINTS from '../../constants/deviceBreakpoints';

const { MOBILE, TABLET, LAPTOP } = DEVICE_BREAKPOINTS;

const options = {
  breakpoints: [`${MOBILE}px`, `${TABLET}px`, `${LAPTOP}px`]
};

// customized breakpoints for rebass grid
const Theme = props => (
  <ThemeProvider {...props} theme={options} />
);

export default Theme;
